(function (global, factory) {
  "use strict";

  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (global) global.BBSupplierThumbnails = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  function stringUrl(value) {
    if (value && typeof value === "object") value = value.url;
    return typeof value === "string" ? value.trim() : "";
  }

  function imageCandidates(line, brandUrl) {
    line = line || {};
    var candidates = [
      { url: stringUrl(line.zakeke_preview_url), kind: "zakeke" },
      {
        url: stringUrl(line.shopify_image_url || line.image_url || line.image),
        kind: "shopify",
      },
      { url: stringUrl(brandUrl), kind: "brand" },
    ];
    var seen = Object.create(null);
    return candidates.filter(function (candidate) {
      if (!candidate.url || seen[candidate.url]) return false;
      seen[candidate.url] = true;
      return true;
    });
  }

  function imageGroups(line, brandUrl) {
    line = line || {};
    var frontUrl = stringUrl(line.zakeke_preview_url);
    var backUrl = stringUrl(line.zakeke_preview_back_url);
    var primaryLine = line;

    if (!frontUrl && backUrl) {
      primaryLine = {};
      Object.keys(line).forEach(function (key) {
        primaryLine[key] = line[key];
      });
      primaryLine.zakeke_preview_url = backUrl;
    }

    var groups = [
      {
        role: frontUrl ? "front" : backUrl ? "back" : "product",
        optional: false,
        candidates: imageCandidates(primaryLine, brandUrl),
      },
    ];

    if (frontUrl && backUrl && frontUrl !== backUrl) {
      groups.push({
        role: "back",
        optional: true,
        candidates: [{ url: backUrl, kind: "zakeke-back" }],
      });
    }

    return groups.filter(function (group) {
      return group.candidates.length;
    });
  }

  function advanceImage(image) {
    var encoded = image && image.getAttribute("data-image-candidates");
    if (!encoded) return false;
    var candidates;
    try {
      candidates = JSON.parse(decodeURIComponent(encoded));
    } catch (_error) {
      return false;
    }
    var nextIndex = Number(image.getAttribute("data-image-index") || 0) + 1;
    var next = candidates[nextIndex];
    if (!next || !next.url) return false;
    image.setAttribute("data-image-index", String(nextIndex));
    image.setAttribute("data-image-kind", next.kind || "shopify");
    image.setAttribute("src", next.url);
    return true;
  }

  return {
    imageCandidates: imageCandidates,
    imageGroups: imageGroups,
    advanceImage: advanceImage,
  };
});
